
// import { Button } from "../../src/components/ui/button";
// import { CheckCircle } from "lucide-react";
// import { useNavigate } from "react-router-dom";

// export default function SuccessPage() {
//   const navigate = useNavigate();

//   const handleSubmit = () => {
//     console.log("Redirected to BMI form");
//     navigate("/");
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
//       <div className="max-w-2xl w-full bg-white rounded-lg shadow-sm p-8 md:p-12 text-center">
//         <div className="flex justify-center mb-6">
//           <div className="bg-red-100 p-4 rounded-full">
//             <CheckCircle className="h-12 w-12 text-[#8B1D1D]" />
//           </div>
//         </div>

//         <h1 className="text-3xl md:text-4xl font-bold text-[#8B1D1D] mb-4">
//           Thank You For Your Response
//         </h1>
//         <Button
//           className="border border-[#8B1D1D] text-[#8B1D1D] bg-gray-50 hover:bg-[#7A1919] px-6 py-2 rounded-md text-lg"
//           onClick={handleSubmit}
//         >
//           Submit Another Response
//         </Button>
//       </div>
//     </div>
//   );
// }

// SuccessModal.jsx
import { Button } from "../../src/components/ui/button";
import { CheckCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
export default function SuccessModal({ onClose }) {
    const navigate = useNavigate();

  const handleSubmit = () => {
    console.log("Redirected to BMI form");
    onClose();
    navigate("/");
  };
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="max-w-xl w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-red-100 p-4 rounded-full">
            <CheckCircle className="h-12 w-12 text-[#8B1D1D]" />
          </div>
        </div>
        <h1 className="text-3xl font-bold text-[#8B1D1D] mb-4">
          Thank You For Your Response
        </h1>
        <Button
           className="border border-[#8B1D1D] text-[#8B1D1D] bg-gray-50 hover:bg-[#7A1919] px-6 py-2 rounded-md text-lg"
           onClick={handleSubmit}
         >
          Submit Another Response
         </Button>
        {/* <Button
          className="border border-[#8B1D1D] text-[#8B1D1D] bg-gray-50 hover:bg-[#7A1919] px-6 py-2 rounded-md text-lg"
          onClick={onClose}
        >
          Submit Another Response
        </Button> */}
      </div>
    </div>
  );
}
